/* eslint-disable no-console, no-unused-vars, no-param-reassign */

import Immutable, { Map } from 'immutable';
import stringify from 'json-stringify-safe';
import { createTransform } from 'redux-persist';
import Serialize from 'remotedev-serialize';

import Logger from '../tools/Logger';

const log = Logger.child({ component: 'lib/ImmutableMigrationTransform' });

export const MIGRATION_KEYS = ['loginAuthToken', 'username', 'loginRememberMe'];

export const WINDOW_MIGRATION_KEY = Symbol('windowMigration');

function createSerializer() {
  return (state, key) => {
    if (typeof state !== 'string') {
      state = stringify(state);
    }
    return state;
  };
}

function addKeyToMigrationKeys(migrationKeys, key, state) {
  const test = new RegExp(`"(${key})",(.*?),`);
  try {
    const matches = test.exec(state);
    const parsedMigrationValue = JSON.parse(matches[2]);
    migrationKeys[key] = parsedMigrationValue;
  } catch (e) {
    log.warn(`Tried to migrate key, ${key}, but failed`);
  }
}

function extractStorageState(state) {
  try {
    return JSON.stringify({
      version: JSON.parse(state).pop(),
    });
  } catch (e) {
    // Default, this upgrade occurred while the store version was 3
    return JSON.stringify({
      version: 3,
    });
  }
}

function createDeserializer(shouldDoMigrationTasks) {
  return (state, key) => {
    if (typeof state !== 'string') {
      log.error('expected outbound state to be a string');

      return state;
    }

    try {
      if (!shouldDoMigrationTasks(state)) return state;
      if (key === 'storage') {
        return extractStorageState(state);
      }
      if (key === 'login') {
        window[WINDOW_MIGRATION_KEY] = {};
        MIGRATION_KEYS.forEach(migrationKey => {
          addKeyToMigrationKeys(window[WINDOW_MIGRATION_KEY], migrationKey, state);
        });
        return null;
      }
    } catch (err) {
      log.error(err);
      return null;
    }
    return null;
  };
}

function testIfUsingOldSerializationFactory(serializer) {
  let isUsingOldVersion = false;
  let hasCalculated = false;
  return state => {
    if (hasCalculated) return isUsingOldVersion;
    try {
      const parsed = serializer.parse(state);
      // The transit-style parses to ['~M', ['blah']]
      if (Array.isArray(parsed)) {
        isUsingOldVersion = true;
      } else {
        isUsingOldVersion = false;
      }
    } catch (e) {
      isUsingOldVersion = true;
    }
    hasCalculated = true;
    return isUsingOldVersion;
  };
}

export default function () {
  const serializer = Serialize.immutable(Immutable);
  const shouldDoMigrationTasks = testIfUsingOldSerializationFactory(serializer);
  const inbound = createSerializer();
  const outbound = createDeserializer(shouldDoMigrationTasks);

  return createTransform(inbound, outbound);
}
